import { useEffect, useState } from "react";
import CookiesConsentStepOne from "./CookiesConsentStepOne";
import CookiesConsentStepTwo from "./CookiesConsentStepTwo";

const CookiesConsent = () => {
  const localStorageKey = "lanchas-cookie-preferences";
  const [currentView, setCurrentView] = useState(0);

  const handleConfigurePreferences = () => setCurrentView(1);
  const [cookiePreferences, setCookiePreferences] = useState<CookiePreferences | null>(null);
  const [savedCookiePreferences, setSavedCookiePreferences] = useState(false);

  const handleOnAcceptCookies = () => {
    localStorage.setItem(
      localStorageKey,
      JSON.stringify({
        analytical: true,
        personalisation: true,
        advertising: true,
      })
    );
    setSavedCookiePreferences(true);
  };

  const handleOnRejectCookies = () => {
    localStorage.setItem(
      localStorageKey,
      JSON.stringify({
        analytical: false,
        personalisation: false,
        advertising: false,
      })
    );
    setSavedCookiePreferences(true);
  };

  const handleOnSavePreferences = () => {
    localStorage.setItem(localStorageKey, JSON.stringify(cookiePreferences));
    setSavedCookiePreferences(true);
  };

  const handleOnChange = (event: any) => {
    setCookiePreferences({
      ...cookiePreferences!,
      [event.target.name]: event.target.checked,
    });
  };

  useEffect(() => {
    let cookiePreferencesStored = localStorage.getItem(localStorageKey);

    if (cookiePreferencesStored) {
      setSavedCookiePreferences(true);
      setCookiePreferences(JSON.parse(cookiePreferencesStored));
    } else {
      setCookiePreferences({
        analytical: true,
        personalisation: true,
        advertising: true,
      });
    }
  }, []);

  return (
    <>
      {!savedCookiePreferences && currentView === 0 ? (
        <CookiesConsentStepOne
          onClickConfigurePreferences={handleConfigurePreferences}
          onAcceptCookies={handleOnAcceptCookies}
          onRejectCookies={handleOnRejectCookies}
        />
      ) : !savedCookiePreferences && currentView === 1 ? (
        <CookiesConsentStepTwo
          onSavePreferences={handleOnSavePreferences}
          onChange={handleOnChange}
          cookiePreferences={cookiePreferences!}
          onAcceptCookies={handleOnAcceptCookies}
          onRejectCookies={handleOnRejectCookies}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default CookiesConsent;
